'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isObject = exports.isObject = function isObject(someVar) {
  return someVar instanceof Object;
};
var isCityObject = exports.isCityObject = function isCityObject(someVar) {
  return "cityId" in someVar;
};
var appendSlashIfNeeded = exports.appendSlashIfNeeded = function appendSlashIfNeeded(text) {
  return text[text.length - 1] !== '/' ? text + '/' : text;
};
var prependHttpIfNeeded = exports.prependHttpIfNeeded = function prependHttpIfNeeded(url) {
  var cleanedUrl = url.trim().split("?")[0];
  var absoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//?', 'i');
  if (absoluteUrlRegex.test(cleanedUrl)) return url;
  if (cleanedUrl.split("/")[0].includes('.')) return 'http://' + url.trim();
  return url;
};
var getImageNameFromUrl = exports.getImageNameFromUrl = function getImageNameFromUrl(url) {
  if (!url) return "";
  var nameWithExtension = url.split("/").pop();
  return nameWithExtension.split(".")[0].replace(/\d+$/, "");
};
var getQueryParam = exports.getQueryParam = function getQueryParam(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var filterAndSortAttendeeTypes = exports.filterAndSortAttendeeTypes = function filterAndSortAttendeeTypes(attendeeTypes, displayedAttendeeTypes) {
  var attendeeTypeIds = displayedAttendeeTypes || [];
  if (attendeeTypes && !attendeeTypeIds.length) attendeeTypeIds = Object.keys(attendeeTypes);
  attendeeTypeIds = attendeeTypeIds.filter(function (id) {
    return !!attendeeTypes[id];
  });
  return attendeeTypeIds.sort(function (id1, id2) {
    return attendeeTypes[id1].order - attendeeTypes[id2].order;
  });
};
var buildStyleTagWithFontFaces = exports.buildStyleTagWithFontFaces = function buildStyleTagWithFontFaces(fontValues, familyName) {
  var styleString = '<style type=\'text/css\'>';
  var fontFamilyValues = fontValues.filter(function (f) {
    return f.name === familyName;
  });
  fontFamilyValues.forEach(function (f) {
    return styleString += '@font-face{\n                                                  font-family: ' + f.name + ';\n                                                  src: url(' + f.source + ');\n                                                  font-weight: ' + f.weight + ';\n                                                  font-style: ' + f.style + ';\n                                                }';
  });
  styleString += '</style>';
  return styleString;
};
var buildFontFaces = exports.buildFontFaces = function buildFontFaces(globalFontId, accountFonts) {
  var currentFont = accountFonts[parseInt(globalFontId)];
  var familyName = currentFont.name;
  var fontValues = Object.values(accountFonts);
  return buildStyleTagWithFontFaces(fontValues, familyName);
};